import Skeleton from "@mui/material/Skeleton";
import React from "react";
import Box from "@mui/material/Box";
import RateReviewIcon from '@mui/icons-material/RateReview';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useHistory } from "react-router-dom";
import CourseRewards from "./mycourses/CourseRewards";
import ProgressTracker from "./mycourses/ProgressTracker";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import dateFormat from "dateformat";
import defaultdp from "../../assets/icons/defaultdp.svg";
import DetectDevice from "../../data/DetectDevice";
import CourseDashboardStats from "../../actions/CourseDashboardStats";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useState } from "react";
import Localbase from "localbase";
import SetPage from "../../data/SetPage";
import TrackJourney from "../../actions/course/TrackJourney";
import ModalStyle from "../../data/ModalStyle";
import myclasses from "../../assets/dashboard/classes.svg";
import notesicon from "../../assets/dashboard/notes.svg";
import assignmentsicon from "../../assets/dashboard/assignments.svg";
import recordingsicon from "../../assets/dashboard/recordings.svg";
import projectsicon from "../../assets/dashboard/projects.svg";
import rewardsicon from "../../assets/dashboard/rewards.svg";
import supporticon from "../../assets/dashboard/support.svg";
import placementicon from "../../assets/dashboard/placement.svg";
import Alert from "@mui/material/Alert";
import PaidIcon from '@mui/icons-material/Paid';

import ClassItem from "./mycourses/ClassItem";
import TeamLeaderboard from "./mycourses/TeamLeaderboard";
import { Download } from "@mui/icons-material";
import CourseBatchChat from "./CourseBatchChat";
import teamicon from "../../assets/images/teamicon.svg";
import ClassesCalander from "./mycourses/ClassesCalander";
import PreviousScheduleItem from "./PreviousScheduleItem";
import UploadStudentIdCard from "./UploadStudentIdCard";
import IDCardRequest from "./IDCardRequest";
import axios from "axios";
import ENDPOINT from "../../data/ENDPOINT";
import SecurityHeaders from "../../data/SecurityHeaders";
import styled from "styled-components";
import WeeklyFeedback from "../../components/modals/WeeklyFeedback";




import { User, CreditCard, Badge, Star, Video, FileText, BookOpen, ClipboardList, FolderOpen, Gift, HelpCircle, Briefcase, Coins, TestTube, Database, } from "lucide-react";
import { get } from "@firebase/database";

const MyCourseDashboard = ({ account }) => {
  const history = useHistory();
  const params = useParams();
  const course_url = params.course_url;
  const batch_id = params.batch_id;
  const { user } = useContext(AuthContext);
  const [loading, setloading] = useState(true);
  const [previous_classes, setpreviousclasses] = useState([])
  useEffect(() => {
    window.scrollTo(0, 0);
    CourseJourney();
  }, []);
  let db = new Localbase("db");
  const [course, setcourse] = useState(null);
  const [classes, setclasses] = useState(null);
  const [recordings, setrecordings] = useState(null);
  const [lessons, setlessons] = useState(null);
  const [learnings, setlearnings] = useState(null);
  const [upcominClasses, setUpcomingClasses] = useState([])
  const [activeassignments, setAssignments] = useState([])
  const Statistics = async () => {
    const res = await CourseDashboardStats({
      payload: {
        user: user.SessionId,
        course_url: course_url,
        batch_id: batch_id,
      },
    });

    if (res) {
      //  //  //console.log("dash "+JSON.stringify(res))
      if (res.status === "success") {
        setlessons(res.lessons);
        setcourse(res.course);
        setclasses(res.classes);
        setrecordings(res.recordings);
        setlearnings(res.learnings);
        setloading(false);

        let path = "course_" + course_url;
        db.collection("paths").add(
          {
            my_course: res.course,
          },
          "my_course",
        );
        db.collection("paths").add(
          {
            classes: res.classes,
          },
          "classes",
        );

        db.collection("paths").add(
          {
            recordings: res.recordings,
          },
          "recordings",
        );

        Animate();
      }
      //  //  //console.log("dash "+JSON.stringify(res))
    }
  };

  useEffect(() => {
    SetPage("My Course");
    db.collection("paths")
      .doc("my_course")
      .get()
      .then((course) => {
        setcourse(course.my_course);
      })
      .catch((error) => { });

    db.collection("paths")
      .doc("classes")
      .get()
      .then((course) => {
        setclasses(course.classes);
      })
      .catch((error) => { });

    db.collection("paths")
      .doc("recordings")
      .get()
      .then((course) => {
        setrecordings(course.recordings);
      })
      .catch((error) => { });
    Statistics();
  }, []);

  const newdevice = DetectDevice();

  const [cart, setsestate] = useState();

  const [journey, setjourney] = useState(null);

  const [doubtStatistics, setDoubtStatistics] = useState({
    doubt_limit: 3000,
    doubt_score: 0,
    request_permission: true
  })



  const navigationItems = [
    {
      id: 'classes',
      label: 'Classes',
      info: "Join live and upcoming sessions",
      icon: Video,
      color: '#f97316',
      gradientClass: 'nav-gradient-orange',
      link: `/classes/${course_url}/batch${batch_id}`,
    },
    {
      id: 'recordings',
      label: 'Recordings',
      info: "Watch previously conducted classes",
      icon: FileText,
      color: '#111827',
      gradientClass: 'nav-gradient-dark',
      link: `/recordings/${course_url}/${batch_id}/0`,
    },
    // {
    //   id: 'notes',
    //   label: 'Notes',
    //   info: "Access course notes and materials",
    //   icon: BookOpen,
    //   color: '#22c55e',
    //   gradientClass: 'nav-gradient-green',
    //   link: `/course-notes/${course_url}`,
    // },
    {
      id: 'assignments',
      label: 'Assignments',
      info: "Practice with assigned tasks",
      icon: ClipboardList,
      color: '#f59e0b',
      gradientClass: 'nav-gradient-amber',
      link: `/assignments/${course_url}/${batch_id}`,
    },
    {
      id: 'projects',
      label: 'Projects',
      info: "Build real-world projects",
      icon: FolderOpen,
      color: '#ef4444',
      gradientClass: 'nav-gradient-red',
      link: `/projects/${course_url}/${batch_id}`,
    },
    // {
    //   id: 'rewards',
    //   label: 'Rewards',
    //   info: "Track rewards and achievements",
    //   icon: Gift,
    //   color: '#ec4899',
    //   gradientClass: 'nav-gradient-pink',
    //   link: `/course-rewards/${course_url}`,
    // },
    {
      id: 'support',
      label: 'Support',
      info: "Get help from trainers and support",
      icon: HelpCircle,
      color: '#6366f1',
      gradientClass: 'nav-gradient-indigo',
      link: `/trainer-support/${course_url}/${batch_id}`,
    },
    {
      id: 'placements',
      label: 'Placements',
      info: "Prepare for jobs and placements",
      icon: Briefcase,
      color: '#14b8a6',
      gradientClass: 'nav-gradient-teal',
      link: `/placement-cell/${course_url}/${batch_id}`,
    },
  ];


  const CourseJourney = async () => {
    const res = await TrackJourney({
      payload: {
        user: user.SessionId,
        course_url: course_url,
        batch_id: batch_id,
      },
    });
    if (res) {
      if (res.status === "success" && res.data != null) {
        setjourney(res.data);
      }
      //   //  //console.log("journey "+JSON.stringify(res))
    }
  };

  const Animate = () => {
    const items = document.getElementsByClassName("animate");

    const screenheight = window.innerHeight;
    for (var i = 0; i <= items.length; i++) {
      const currentelement = items[i];

      if (currentelement) {
        const elementposition = parseInt(
          currentelement.getBoundingClientRect().top.toFixed(),
        );

        if (elementposition < screenheight) {
          if (items[i].classList.contains("animation-active")) {
          } else {
            items[i].classList.add("animation-active");
          }
        }
      }
    }
  };
  const device = DetectDevice()
  useEffect(() => {
    SetPage("My Course");
  }, []);

  const [modal, setmodal] = useState(false);

  const DownloadIdCard = ({ data }) => {
    const imageUrl = data.id_card;

    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);

        // Create an anchor element
        const a = document.createElement("a");
        a.href = url;

        // Set the download attribute to specify the filename for the downloaded file
        a.download = "skillsupriseethical-hacking-specialization.png";

        // Trigger a click event on the anchor element to start the download
        a.click();

        // Clean up the URL object
        URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading the image:", error);
      });
  };

  const [videoPermission, setVideoPermission] = useState('active');
  const [weeklyFeedback, setWeeklyFeedback] = useState(false);

  const checkWeekFeedback = async () => {
    try {
      const data = new FormData();
      data.append("session", user.SessionId);
      const response = await axios.post(ENDPOINT + "check-saturday-feedback.php", data, SecurityHeaders);
      if (response.data.status) {
        setWeeklyFeedback(response.data.status);
      }
    } catch (error) {
      console.error("Error getting user media: ", error);
      return false;
    }
  };
  // console.log(weeklyFeedback);
  const checkVideoPermission = async () => {
    try {
      const data = new FormData();
      data.append("session", user.SessionId);
      const response = await axios.post(ENDPOINT + "check_course_dashboard_video_permission.php", data, SecurityHeaders);
      if (response.data.status === "success") {
        setVideoPermission(response.data.video_status);
      }
    } catch (error) {
      console.error("Error getting user media: ", error);
      return false;
    }
  };

  const getvideos = async () => {
    if (!user.SessionId) {
      // settoastmessage("Cannot fetch videos: Missing session or CSRF token");
      // settoast(true);
      setloading(false);
      return;
    }

    try {
      const response = await fetch(
        `${ENDPOINT}get-recording.php?id=0&session=${user.SessionId}&batch_id=${batch_id}&course_url=${course_url}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const result = await response.json();
      if (result.status === "error") {
        throw new Error(result.message);
      }
      setpreviousclasses(result.previous_classes);
    } catch (error) {
      // settoastmessage("Error fetching videos: " + error.message);
      // settoast(true);
    } finally {
      setloading(false);
    }
  };
  const getClasses = async () => {
    if (!user.SessionId) return;

    try {
      const formData = new FormData();
      formData.append("session", user.SessionId);
      formData.append("batch_id", batch_id);
      formData.append("course_url", course_url);
      formData.append("status", "incomplete");

      const res = await fetch(`${ENDPOINT}live-schedule.php`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        console.warn("Live schedule API failed:", res.status);
        return;
      }

      const data = await res.json();

      if (data.status === "success") {
        // console.log(data.data, "get courses")
        setUpcomingClasses(data.data)
      } else {
        setUpcomingClasses([]);
      }
    } catch (error) {
      console.error("Live schedule error:", error.message);
      setUpcomingClasses([]);
    }
  };
  const getAssignments = async () => {
    if (!user.SessionId) return;

    try {
      const formData = new FormData();
      formData.append("session", user.SessionId);
      formData.append("batch_id", batch_id);
      formData.append("course_url", course_url);

      const res = await fetch(`${ENDPOINT}get-assignments.php`, {
        method: "POST",
        body: formData,
      });

      if (!res.ok) {
        console.warn("Live schedule API failed:", res.status);
        return;
      }

      const data = await res.json();

      if (data.status === "success") {
        console.log(data.data, "get assignments")
        setAssignments(data.data)
      } else {
        setAssignments([]);
      }
    } catch (error) {
      console.error("Live schedule error:", error.message);
      setAssignments([]);
    }
  };


  useEffect(() => {
    checkVideoPermission();
    checkWeekFeedback();
    getvideos();
    getClasses();
    // getAssignments();
  }, [user.SessionId]);
  // console.log(typeof(videoPermission));

  const updateVidePermissions = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append("session", user.SessionId);
      const response = await axios.post(ENDPOINT + "course_dashboard_video_permission.php", data, SecurityHeaders);
      if (response.data.status === "success") {
        setVideoPermission("active");
      }
    } catch (error) {
      console.error("Error updating video permissions: ", error);
    }
  };

  const handleWeeklyFeedback = (e) => {

    setWeeklyFeedback(false);
  };




  return (
    <div className="">

      <style>{`
      /* ================= ROOT ================= */
:root {
  --brand-orange: #f15e22;
  --brand-orange-soft: #ffb089;
  --text-dark: #111827;
  --text-muted: #6b7280;
  --card-bg: #ffffff;
  --panel-bg: #f4f5f7;
  --panel-header: #eceef1;
  --border-light: #e5e7eb;
}

/* ================= DASHBOARD LAYOUT ================= */
.dashboard-top {
  display: flex;
  gap: 16px;
  align-items: stretch;
  height: 15rem;
}

.dashboard-top > div {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* ================= COMMON CARD ================= */
.luxury-card,
.recordings-panel {
  flex: 1;
  height: 100%;
  border-radius: 18px;
  box-shadow: 0 14px 40px rgba(0,0,0,0.18);
  overflow: hidden;
}

/* ================= PROFILE / LEFT ================= */
.luxury-card {
  background: var(--card-bg);
  color: #000;
}

/* ================= UPCOMING CLASSES ================= */
.upcoming-classes {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.upcoming-classes .recordings-body {
  flex: 1;
  overflow-y: auto;
}

/* ================= RECORDINGS / RIGHT ================= */
.recordings-panel {
  display: flex;
  flex-direction: column;
  background: var(--panel-bg);
  color: var(--text-dark);
}

.recordings-header {
  padding: 16px 18px;
  font-size: 18px;
  font-weight: 600;
  background: var(--panel-header);
  border-bottom: 1px solid #d1d5db;
  flex-shrink: 0;
}

.recordings-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px;
}

/* ================= RECORDING ITEM ================= */
.recording-item {
  background: #fff;
  border: 1px solid var(--border-light);
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.recording-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

.recording-title {
  font-weight: 600;
  color: var(--text-dark);
}

.recording-item small {
  color: var(--text-muted);
}

/* ================= SCROLLBAR ================= */
.recordings-body::-webkit-scrollbar {
  width: 6px;
}
.recordings-body::-webkit-scrollbar-thumb {
  background: #c7c9cf;
  border-radius: 6px;
}

/* ================= NAV CARDS ================= */
.card-hover {
  background: #fff;
  border-radius: 16px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.card-hover:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(0,0,0,0.15);
}

/* ================= BADGES ================= */
.badge {
  background: #111827 !important;
  color: #fff !important;
  border-radius: 999px;
}

/* ================= PROFILE RING ================= */
.bg-gradient-ring {
  background: linear-gradient(135deg, #ff7a18, #f15e22);
  padding: 4px;
  border-radius: 50%;
}

.profile-inner {
  background: #fff;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-gradient {
  font-size: 42px;
  font-weight: 700;
  color: var(--brand-orange);
}

/* ================= RESPONSIVE ================= */
@media (max-width: 992px) {
  .dashboard-top {
    height: auto;
  }
}/* ================= UPCOMING CLASSES (COMPACT + SCROLL) ================= */
.recordings-section{
  height:15rem;
}
.upcoming-classes {
  max-height: 180px;              /* CONTROL HEIGHT HERE */
  display: flex;
  flex-direction: column;
  overflow: hidden;

  background: #f8fafc;           /* flat clean bg */
  box-shadow: none !important;    /* kill heavy shadow */
  border: 1px solid #e5e7eb;
}

/* header stays fixed */
.upcoming-classes .recordings-header {
  flex-shrink: 0;
  background: #f1f5f9;
  border-bottom: 1px solid #e5e7eb;
  padding: 12px 16px;
}

/* scroll only body */
.upcoming-classes .recordings-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px 14px;
}

/* individual class row */
.upcoming-card {
  background: transparent;
  padding: 8px 0;
  border-bottom: 1px solid #e5e7eb;
}

.upcoming-card:last-child {
  border-bottom: none;
}

/* title compact */
.upcoming-card h6 {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}

/* time text */
.upcoming-card .text-muted {
  font-size: 12px;
}

/* view button smaller */
.upcoming-card .btn {
  padding: 4px 10px;
  font-size: 12px;
}

/* scrollbar clean */
.upcoming-classes .recordings-body::-webkit-scrollbar {
  width: 4px;
}

.upcoming-classes .recordings-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 6px;
}

/* ================= RESPONSIVE ================= */

@media (max-width: 768px) {
  .upcoming-classes {
    max-height: 180px;
  }
}/* ===== EMPTY STATE LAYOUT ===== */

.empty-cta-grid.fill-space {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  height: 100%;
  min-height: 220px;
  align-items: stretch;
}

/* ===== CARD BASE ===== */

.empty-cta-card.vertical {
  border: 1.5px solid #e5e7eb;
  border-radius: 18px;
  text-decoration: none;

  padding: 24px 18px;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;

  transition: all 0.25s ease;
}

/* hover */
.empty-cta-card.vertical:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(0,0,0,0.08);
}

/* ===== ICON ===== */

.empty-cta-card.vertical .cta-icon {
  font-size: 42px;
  line-height: 1;
}

/* ===== TEXT ===== */

.cta-content {
  text-align: center;
}

.cta-content h6 {
  font-size: 17px;
  font-weight: 700;
  margin: 0;
}

.cta-content p {
  font-size: 14px;
  margin: 6px 0 0;
  color: #6b7280;
  line-height: 1.4;
}

/* ===== THEMES ===== */

.empty-cta-card.support {
  background: #f5f7ff;
  color: #4338ca;
}

.empty-cta-card.placement {
  background: #ecfdf5;
  color: #047857;
}

/* ===== MOBILE ===== */

@media (max-width: 640px) {
  .empty-cta-grid.fill-space {
    grid-template-columns: 1fr;
    min-height: 260px;
  }
}
  /* reduce overall empty state height */
.empty-cta-grid.fill-space {
  min-height: 150px;      /* ⬅️ was 220px */
  gap: 14px;              /* slightly tighter */
}

/* reduce individual card size */
.empty-cta-card.vertical {
  padding: 16px 14px;     /* ⬅️ was 24px 18px */
  min-height: 90px;       /* ⬅️ smaller card */
}

/* reduce icon size */
.empty-cta-card.vertical .cta-icon {
  font-size: 32px;        /* ⬅️ was 42px */
}

/* tighten text */
.cta-content h6 {
  font-size: 15px;        /* ⬅️ was 17px */
}

.cta-content p {
  font-size: 13px;
  margin-top: 4px;
}


`}</style>

      {weeklyFeedback === true ?

        <div className="container">
          <Modal
            open={weeklyFeedback}


          >
            <WeeklyFeedback course={{ course_url: course_url, batch_id: batch_id }} show={''} onHandelClose={handleWeeklyFeedback} />
          </Modal>
        </div> : <></>

      }
      {course ? <>
        {
          videoPermission === 'active' ?
            <div className="pb-5">
              <CourseBatchChat data={course} course_title={course.course_title} />

              <Modal open={modal} onClose={() => setmodal(false)}>
                <Box className="col-lg-4 col-11 p-3" sx={ModalStyle}>
                  <div className="modal-header">
                    <h4>Student access only !</h4>
                    <CloseIcon className="click" onClick={() => setmodal(false)} />
                  </div>

                  <div className="p-2">
                    <p>
                      {course.mode === "free" &&
                        course_url === "website-development" ? (
                        <>
                          You can access these resources only after your classes are
                          commenced.
                        </>
                      ) : (
                        <>Please register a paid course to access this feature.</>
                      )}
                    </p>

                    <div className="mt-3 modal-header">
                      <button
                        onClick={() => setmodal(false)}
                        className="btn btn-danger rounded-pill btn-sm"
                      >
                        Cancel
                      </button>
                      <Link
                        to="/courses"
                        className="btn btn-primary rounded-pill btn-sm"
                      >
                        Browse Courses
                      </Link>
                    </div>
                  </div>
                </Box>
              </Modal>
              {/* user profile */}
              <div className="container sm-mt-0 lg-mt-10  sm-p-0  d-flex flex-wrap justify-content-between" >
                <div className="col-12 mt-3">

                  <div className="dashboard-top d-flex flex-column flex-lg-row gap-3">
                    <div className="luxury-card animate-fade-in position-relative overflow-hidden p-4 col-12 col-lg-7">
                      {/* Background Blur Gradients */}
                      <div className="position-absolute top-0 end-0 bg-blur-circle"></div>
                      <div className="position-absolute bottom-0 start-0 bg-blur-circle-alt"></div>

                      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3 flex-wrap">

                        {/* Profile Image Section */}
                        <div className="position-relative mx-auto mx-sm-0 d-flex align-items-center">

                          <div>
                            <div className="bg-gradient-ring m-2 rounded-circle  " style={{ width: "112px", height: "112px" }}>
                              <div className="profile-inner rounded-circle">
                                {account.profile_pic && account.profile_pic ? (
                                  <img
                                    src={account.profile_pic && account.profile_pic}
                                    alt="Profile"
                                    className="w-100 h-100 object-fit-cnavbarover rounded"
                                  />
                                ) : (
                                  <span className="text-gradient">
                                    {(account.first_name && account.first_name.charAt(0)) || "R"}
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* Floating Star Badge */}
                            <div className="badge-floating">
                              <Star size={12} color="#fff" />
                            </div>


                            {/* Status Indicator*/}
                            {/* <div className="status-indicator">
                              <div className="dot position-absolute top-50 start-50 translate-middle"></div>
                            </div> */}

                          </div>



                          <div className=" ms-1 custom-margin " style={{ marginTop: "-26px" }}>
                            <div className="d-flex flex-row align-items-center gap-2 flex-wrap mt-4">
                              <h4
                                className="text-gradient-heading mb-0 fs-5 mb-0 pb-0 fs-sm-4 truncate-sm"
                              >
                                {account.first_name + " " + account.last_name}
                              </h4>


                              <span className="badge d-none d-sm-inline mb-0 mt-0 pb-1 pt-1">PRO</span>

                            </div>
                            <p className="fw-semibold text-dark fw-bold ">{course.course_title}</p>
                            <div className="gap-2 d-flex flex-wrap">
                              <p className="badge text-light py-1 px-2">Batch Title : {course.batch_name}</p>
                              <p className="badge text-light py-1 px-2"> Batch ID: {course.batch_id}</p>
                              </div>
                            <p className="text-success d-flex align-items-center bg-grey px-2 rounded-pill mt-1" style={{width:"fit-content"}}>
                              <span className="status-indicator me-1">
                                <span className="dot position-absolute top-50 start-50 translate-middle sm-small"></span>
                              </span>
                              Active Student
                            </p>
                          </div>

                        </div>


                        {/* Divider for small screens */}
                        <hr className="m-0 pb-0 d-none d-md-block" style={{ borderTop: "1px solid #000", width: "100%" }} />


                        {/* Profile Info Section */}
                        <div className="flex-grow-1 text-center text-sm-start w-100 d-none d-md-block">
                          {/* Extra Stats */}
                          <div className="small pt-0">
                            <div className="d-flex gap-3">
                              <div className="d-flex align-items-center gap-2">
                                <div className="status-dot bg-success"></div>
                                <span>Profile updated recently</span>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                <div className="status-dot bg-primary"></div>
                                <span>Rank: {course.rank || "NA"}</span>
                              </div>
                              <div className="d-flex align-items-center gap-2">
                                <div className="status-dot bg-purple"></div>
                                <span>Total Points: {course.total_marks || 0}</span>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-lg-5 d-flex flex-column recordings-section">
                      <div className="recordings-panel luxury-card ">

                        {upcominClasses && !previous_classes.length > 2 && upcominClasses.length > 0 ? <>
                          <div className="recordings-header d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Upcoming Classes</h5>
                            <Link
                              to={`/classes/${course_url}/batch${batch_id}`}
                              className="small text-decoration-none fw-semibold"
                            >
                              View all →
                            </Link>
                          </div>

                          <div className="recordings-body">
                            {upcominClasses && upcominClasses.length > 0 ? (
                              upcominClasses.map((cls) => (
                                <div key={cls.id} className="upcoming-card mb-2">
                                  <div className="d-flex flex-column gap-2">

                                    <h6 className="fw-bold mb-1">
                                      {cls.class_title}
                                    </h6>

                                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                      <div className="text-muted small">
                                        {dateFormat(cls.class_starts, "ddd, mmm d, yyyy")} ·{" "}
                                        {dateFormat(cls.class_starts, "h:MM TT")}
                                      </div>

                                      <Link
                                        to={`/classes/${course_url}/batch${batch_id}`}
                                        className="btn btn-success rounded-pill px-3 .fs-6"
                                      >
                                        Join Class
                                      </Link>
                                    </div>

                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="text-center text-muted py-4">
                                No upcoming classes scheduled
                              </div>
                            )}
                          </div>
                        </> : <>
                          <div className="recordings-header">
                            <h5 className="mb-0">🎥 Recordings</h5>
                          </div>

                          <div className="recordings-body">
                            {previous_classes && previous_classes.length > 0 ? (
                              previous_classes.map((item) => (
                                <div
                                  key={item.id}
                                  className="recording-item"
                                  onClick={() =>
                                    history.push(
                                      `/recordings/${item.course_url}/${item.batch_id}/${item.id}`
                                    )}
                                >
                                  <div className="d-flex align-items-center gap-2">
                                    <PlayCircleIcon sx={{ color: "#f97316" }} fontSize="large" />
                                    <div>
                                      <div className="recording-title">
                                        {item.class_title || "Untitled Class"}
                                      </div>
                                      <small className="text-dark">
                                        {item.class_starts
                                          ? item.class_starts.split(" ")[0]
                                          : ""}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p className="text-light text-center mt-md-3">
                                No recordings available
                              </p>
                            )}
                          </div></>}
                      </div>
                    </div>

                  </div>
                  <div className="d-flex col-12 flex-wrap px-3 px-sm-0 mt-md-2 mt-lg-3">
                    {navigationItems.map((item) => (
                      <div key={item.id} className="mt-1 mb-1 p-1 col-6 col-sm-4">
                        <Link to={item.link} className="text-decoration-none">
                          <div
                            className={`card h-100 border-0 shadow-lg card-hover position-relative overflow-hidden ${item.gradientClass}`}
                          >
                       <div className="card-body d-flex align-items-center gap-3 px-4 flex-column flex-lg-row">

                              {/* Icon */}
                              <div
                                className="icon-box d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                                style={{
                                  backgroundColor: item.color,
                                  width: "52px",
                                  height: "52px",
                                }}
                              >
                                <item.icon size={26} color="#fff" />
                              </div>

                              {/* Text */}
                              <div className="d-flex flex-column justify-content-center text-start text-md-center text-lg-start">
                                <h5 className="fw-bold text-dark mb-0 pb-0 fs-5 fs-sm-6">
                                  {item.label}
                                </h5>
                                <span className="text-secondary mt-0 pt-0 small d-none d-md-block">
                                  {item.info}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                  <div className="col-12 d-flex flex-column flex-lg-row container mt-0">
                    <div className="d-flex flex-column justify-content-center mt-3 mb-4 col-12 col-lg-6 gap-3">
                      <Link
                        to={`/resources/${course_url}/${batch_id}`}
                        className="fade-in-bottom delay4s br-5 text-light bg-image resource-bg w-100"
                      />

                      <Link
                        to={`/test-topics/mock-test/${course_url}`}
                        className="fade-in-bottom delay4s br-5 text-light bg-image test-bg w-100"
                      />

                    </div>

                    <div className="ms-md-1 col-12 justify-content-center col-lg-6 rounded p-xs-0 p-lg-3">
                      <TeamLeaderboard
                        courseUrl={course_url}
                        batchId={batch_id}
                        teamId={course.team_id}
                      />
                    </div>
                  </div>


                  {course.course_url === "ethical-hacking-free" ||
                    course.course_url === "ethical-hacking" ||
                    course.course_url == "ethical-hacking-specialization" ? (
                    <>
                      <div className="shadow lab-cover mt-2  p-3 lab-card mb-5">
                        <h5 className="hack-green">Hacking challenges</h5>
                        <p className="hack-green-light">
                          Enter a world of codes, exploits, and hidden systems. Every challenge pushes your limits and brings you one step closer to becoming a true cybersecurity expert.
                        </p>
                        <Link to='/hacking-challenges'
                          target="_blank"

                          className="btn btn-primary btn-sm rounded-pill mt-3"
                        >
                          Start Hacking Now
                        </Link>
                      </div>
                    </>
                  ) : (
                    <>{course.course_url === "website-development"}</>
                  )}

                  {journey ? (
                    <>
                      <div className="lg-mt-10 sm-mt-0 sm-p-15 progress-tracker">
                        <ProgressTracker
                          journey={journey}
                          progress={course.progress}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className=" p-2 d-none ">
                        <Alert severity="info">
                          Your progress tracker should be active within 48 hours of
                          your course registration. Please contact your trainer if
                          not active.
                        </Alert>
                      </div>
                    </>
                  )}


                </div>

                {/* <div className="col-lg-5 container col-md-12 col-sm-12 col-12">
                  <CourseBatch more={false} />


                  <div className=" p-3 pt-0 pb-0 shadow d-flex br-5 text-white hacking-line bg-primary">
                    <div className="col-8 py-3">
                      <h5>Become Job Ready !</h5>
                      <p className="extra-small light-grey">
                        Learn the skills that helps you to crack your dream job and
                        earn extra points for every successful milestone.
                      </p>

                      <Link
                        to={"/milestones/" + course_url + "/" + batch_id}
                        className="btn btn-primary rounded-pill btn-sm mt-3"
                      >
                        Start Now
                      </Link>
                    </div>
                    <div className="col-4">
                      <img src="https://skillsuprise.com/resources/images/extra-girl.png" className="w-100"></img>
                    </div>
                  </div>


                  {device === "mobile" && classes ?
                    <>
                      <div className="my-3 p-2 p-md-0">
                        <ClassesCalander classSchedules={classes} className="w-100" />
                      </div>
                    </> :
                    <>

                    </>}


                  {classes && device != "mobile" ?
                    <>
                      <div className="my-3">
                        <ClassesCalander classSchedules={classes} className="w-100" />
                      </div>

                    </> :
                    <>
                    </>}



                  <TeamLeaderboard
                    courseUrl={course_url}
                    batchId={batch_id}
                    teamId={course.team_id}
                    limit={4}
                  />


                  {
                    course.id_card ?
                      null : <>




                      </>
                  }

                  <div className="mt-3  p-3 pt-0 pb-0 shadow d-flex br-5 text-white grey-cta bg-primary">
                    <div className="col-8 py-3">
                      <h5>Earn Course Certificates</h5>
                      <p className="extra-small light-grey">
                        Add an X-Factor to your resume by earning your course
                        certificates. Take up tests and showcase your talents
                      </p>

                      <Link
                        to={"/test-topics/course-certification/" + course_url}
                        className="btn btn-primary rounded-pill btn-sm mt-3"
                      >
                        Get Certified Now
                      </Link>
                    </div>
                    <div className="col-4">
                      <img src="https://skillsuprise.com/resources/images/cert-cta.png" className="w-100"></img>
                    </div>
                  </div>

                </div> */}
              </div>
              <div className="container mt-1 ">
                <>
                  <div className=" col-12 animate course-options mt-3 mb-3">
                    {course && course.mode === "selfpaced" ||
                      course && (course.mode === "free" && lessons) ? (
                      <>
                        <Link
                          to={
                            "/lessons/" +
                            course_url +
                            "/" + (lessons ? lessons[0].topics_chapter_id : "null") +
                            "/" +
                            (lessons ? lessons[0].id : null)
                          }
                          className="btn w-100 fade-in-bottom delay2s rounded-pill btn-sm p-0"
                        >
                          <div className="text-center  bg1">
                            <img
                              className="w-30 mb-2 mx-auto mt-3"
                              src={myclasses}

                            />
                            <p className="">Classes</p>
                          </div>
                        </Link>


                        <Link
                          className="fade-in-bottom delay2s"
                          to={
                            "/recordings/" + course_url + "/" + batch_id + "/0"
                          }
                        >
                          <div className="text-center bg2 ">
                            <img
                              className="w-30 mb-2 mx-auto"
                              src={recordingsicon}
                            />
                            <p>Recordings</p>
                          </div>
                        </Link>
                      </>
                    ) : (
                      <>


                      </>
                    )}



                    {newdevice === "mobile" ? (
                      <>
                        {/* <Link onClick={() => setmodal(true)}>
                          <div className="text-center bg1">
                            <img
                              className="w-30 mb-2 mx-auto"
                              src={placementicon}
                            />
                            <p>Leaderboard ffff</p>
                          </div>
                        </Link> */}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>


                </>


                {classes ? (
                  <>
                    <div className="mt-4 d-none">
                      <div className="d-flex align-items-center justify-content-between">
                        <h4>
                          Upcoming {classes.length > 1 ? "classes" : "class"}
                        </h4>
                        <Link
                          className="btn btn-outline-primary rounded-pill sm-12"
                          to={"/classes/" + course_url + "/batch" + batch_id}
                        >
                          View All
                        </Link>
                      </div>
                      {classes.map((item, index) => (
                        <>
                          <ClassItem
                            key={item.id}
                            item={item}
                            index={index + 1}
                          />
                        </>
                      ))}
                    </div>
                  </>
                ) : null}

                {course.mode === "selfpaced" ? (
                  <></>
                ) : (
                  <>
                    {recordings ? (
                      <>
                        <div className="mt-5 d-none ">
                          <h4>Previous Classes</h4>

                          {recordings.map((item, index) => (
                            <>
                              <PreviousScheduleItem item={item} index={index} course_url={course_url} batch_id={batch_id} />
                            </>
                          ))}
                        </div>
                      </>
                    ) : null}
                  </>
                )}
              </div>




              {/* <div className="container">
                <div className="d-flex mb-3 mt-5 align-items-center justify-content-between">
                  <h4>Course Rewards</h4>
                  <Link to={"/course-rewards/" + course_url}>View All</Link>
                </div>

                <div className="grid lg-grid-6 grid-2">
                  <CourseRewards />
                </div>
              </div> */}
            </div> : <>

              <div className=" d-flex justify-content-center pb-5 " style={{ backgroundColor: 'rgb(0,0,0,0.5)' }} >
                <div className="col-lg-8 col-md-8 mt-5  col-12 col-xs-12 bg-white p-3 shadow rounded">
                  <video className="col-12" controls="nodownload" src="https://skillsuprise.com/data/videos/course-dashboard-access.mp4"></video>
                  <div className="d-flex click btn align-items-center justify-content-between">
                    <h4 className="text-secondary">How to Access the Dashboard</h4>
                    <UiButton>
                      <button onClick={updateVidePermissions} className="mt-2" >
                        <span>Continue </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 74 74"
                          height="34"
                          width="34"
                        >
                          <circle stroke-width="3" stroke="black" r="35.5" cy="37" cx="37"></circle>
                          <path
                            fill="black"
                            d="M25 35.5C24.1716 35.5 23.5 36.1716 23.5 37C23.5 37.8284 24.1716 38.5
       25 38.5V35.5ZM49.0607 38.0607C49.6464 37.4749 49.6464 36.5251 49.0607 
       35.9393L39.5147 26.3934C38.9289 25.8076 37.9792 25.8076 37.3934 26.3934C36.8076
        26.9792 36.8076 27.9289 37.3934 28.5147L45.8787 37L37.3934 45.4853C36.8076
         46.0711 36.8076 47.0208 37.3934 47.6066C37.9792 48.1924 38.9289 48.1924 39.5147
          47.6066L49.0607 38.0607ZM25 38.5L48 38.5V35.5L25 35.5V38.5Z"
                          ></path>
                        </svg>
                      </button>
                    </UiButton>
                  </div>
                </div>
              </div>

            </>
        }</>


        : (
          <>
            <div className="container pb-5 d-flex justify-content-between">
              <div className="col-lg-6">
                <Skeleton className="mb-2 " variant="text" height={400} />

                <div className="grid lg-grid-4 course-options grid-3 mt-3 mb-3">
                  <Skeleton className="mb-2 mt-2" variant="text" height={200} />

                  <Skeleton className="mb-2 mt-2" variant="text" height={200} />

                  <Skeleton className="mb-2 mt-2" variant="text" height={200} />

                  <Skeleton className="mb-2 mt-2" variant="text" height={200} />

                  <Skeleton className="mb-2 mt-2" variant="text" height={200} />

                  <Skeleton className="mb-2 mt-2" variant="text" height={200} />

                  <Skeleton className="mb-2 mt-2" variant="text" height={200} />

                  <Skeleton className="mb-2 mt-2" variant="text" height={200} />
                </div>
              </div>

              <div className="col-lg-5">

                <Skeleton className="mb-2 mt-2" variant="text" height={200} />


                <div className="my-3">
                  <Skeleton
                    className="mb-2 mt-2" variant="text" height={80} />

                  <Skeleton
                    className="mb-2 mt-2" variant="text" height={80} />

                  <Skeleton
                    className="mb-2 mt-2" variant="text" height={80} />

                  <Skeleton
                    className="mb-2 mt-2" variant="text" height={80} />

                </div>
                <Skeleton className="mb-2 mt-2" variant="text" height={200} />

              </div>
            </div>
          </>
        )}
    </div>
  );
};

export default MyCourseDashboard;

export const UiButton = styled.div`


@media (min-width: 769px) {
  .custom-margin {
    margin-top: -40px; /* Apply margin-top for screens > 768px */
  }
}

button {
  cursor: pointer;
  font-weight: 700;
  transition: all 0.2s;
  padding: 10px 20px;
  border-radius: 100px;
  background:rgb(0, 96, 239);
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #fff;}

 button:hover {
    background:rgb(1, 147, 226);
  }

 button> svg {
    width: 34px;
    margin-left: 10px;
    transition: transform 0.3s ease-in-out;
    fill: #fff;
  }

  button:hover svg {
    transform: translateX(5px);
    fill: rgb(1, 147, 226);    
  }

  button:active {
    transform: scale(0.95);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }
`;